
import IndustrySingle from "../../components/layouts/IndustrySingle.vue";

import HeroFull from "../../components/industries/HeroFull.vue";
import FormSection from "../../components/industries/FormSection.vue";
import RowSection from "../../components/industries/RowSection.vue";
import IconsGrid from "../../components/industries/IconsGrid.vue";
import TablesSection from "../../components/industries/TablesSection.vue";
import ContactInfo from "../../components/industries/ContactInfo.vue";

export default {
  components: {
    IndustrySingle,
    HeroFull,
    FormSection,
    RowSection,
    IconsGrid,
    TablesSection,
    ContactInfo,
  },
  data() {
    return {
      gridItems: [
        {
          graphic: "coins.svg",
          title: "Rates starting as low as 8.5%",
          text: "Great Fixed-Interest Rates for many industries",
        },
        {
          graphic: "calendar.svg",
          title: "Terms from 12 - 84 months",
          text: "Flexible repayment terms. Choose what works best for your needs.",
        },
        {
          graphic: "cash.svg",
          title: "Loans from $10K - $10M",
          text: "Different loan amounts for business different needs.",
        },
        {
          graphic: "mobile.svg",
          title: "Fully Digital Application",
          text: "Fast & simple online application. Quick approval decision.",
        },
        {
          graphic: "house.svg",
          title: "Possible funding in just 48 hours",
          text: "Once approved, your funds are immediately sent to your bank.",
        },
        {
          graphic: "247.svg",
          title: "Apply anytime 24/7",
          text: "Apply from home anytime. Never drive to a bank again.",
        },
      ],
      tableItems: [
        {
          title: "Conventional",
          rows: [
            {
              title: "Amount",
              value: "$250k - 30M",
            },
            {
              title: "Term",
              value: "5 - 30 Year",
            },
            {
              title: "LTV",
              value: "up to 80%",
            },
            {
              title: "FICO",
              value: "650+",
            }
          ],
        },
        {
          title: "Bridge Loans",
          rows: [
            {
              title: "Amount",
              value: "$150k - 30M",
            },
            {
              title: "Term",
              value: "1 - 4 Year",
            },
            {
              title: "LTV",
              value: "up to 75%",
            },
            {
              title: "FICO",
              value: "No min FICO",
            }
          ],
        },
        {
          title: "Fix & Flip / Fix & Hold",
          rows: [
            {
              title: "Amount",
              value: "$150k - 15M",
            },
            {
              title: "Term",
              value: "1 - 3 Years interest only",
            },
            {
              title: "LTV",
              value: "70 - 90%\nup to 100% Rehab budget",
            },
            {
              title: "FICO",
              value: "650+",
            }
          ],
        },
        {
          title: "SBA / Business Loans",
          rows: [
            {
              title: "Amount",
              value: "$250k - 25M",
            },
            {
              title: "Term",
              value: "5 - 15 Years interest only\n15, 20, 25 year amortization",
            },
            {
              title: "LTV",
              value: "UP TO 90%",
            },
            {
              title: "FICO",
              value: "650+",
            }
          ],
        }
      ],
    };
  },
  computed: {
    hasSecondRow() {
      return this.$slots["second-row"];
    },
  },
  mounted() {
  },
  head() {
    return {
      title: 'Commercial Real Estate Loans | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'Use your commercial real estate loan to purchase industrial properties, retail properties, warehouses, multi-family homes, and more. Contact us today!'
        }
      ]
    }
  }
};
